import { render, staticRenderFns } from "./MortgagesContact.vue?vue&type=template&id=6a6ce6d3&"
import script from "./MortgagesContact.vue?vue&type=script&lang=ts&"
export * from "./MortgagesContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports